import { cn } from '@/lib/ui/style-helpers'

import { DeltaLine } from '@/components/lemmala-design-system/charts/delta-line/delta-line'

import type { KPICardProps } from './types'
import { kpiCardVariants, kpiLabelVariants } from './variants'

export const KPICard = ({
  label,
  value,
  delta,
  caption,
  footer,
  icon,
  onClick,
  appearance,
  variant,
  className,
}: KPICardProps) => {
  const orientation = icon ? 'leading' : 'stacked'
  const isMetric = appearance === 'metric'
  const text = (
    <>
      <span className={kpiLabelVariants({ compact: isMetric && !icon })}>{label}</span>
      <span className={cn('tabular-nums', isMetric ? 'text-heading-small' : 'text-heading-large')}>
        {value}
      </span>
      {delta && <DeltaLine delta={delta} />}
      {footer}
      {caption && <span className='text-main-foreground-tertiary text-body-small'>{caption}</span>}
    </>
  )

  return (
    <div
      data-testid='kpi-card'
      onClick={onClick}
      className={cn(
        kpiCardVariants({ appearance, variant, orientation, interactive: Boolean(onClick) }),
        className,
      )}
    >
      {icon ? (
        <>
          {icon}
          <div className='flex flex-col'>{text}</div>
        </>
      ) : (
        text
      )}
    </div>
  )
}
